// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2FDIp","header":"MessagesList_header__2nNhc","chat":"MessagesList_chat__2CfQs"};